import constants from 'constants';

const {
  CREATE_SPONSOR_SAGA,
  LOAD_ADMIN_SPONSORS_SAGA,
  ADD_ADMIN_SPONSORS,
  UPDATE_SPONSOR_SAGA,
  DELETE_SPONSOR_SAGA,
  ADMIN_DELETE_SPONSORS_SAGA,
  ADD_SPONSORS,
  LOAD_SPONSORS_SAGA,
  LOAD_SPONSOR_SAGA,
  SET_TEMP_SPONSOR,
  CLEAN_SPONSORS
} = constants;


export const createSponsorSaga = (sponsor) => ({
  type: CREATE_SPONSOR_SAGA,
  sponsor
})

export const updateSponsorSaga = (sponsor) => ({
  type: UPDATE_SPONSOR_SAGA,
  sponsor
})

export const deleteSponsorSaga = (sponsor) => ({
  type: DELETE_SPONSOR_SAGA,
  sponsor
})

export const loadAdminSponsorsSaga = (page = 1, query = {}) => ({
  type: LOAD_ADMIN_SPONSORS_SAGA,
  query,
  page
})

export const loadSponsorsSaga = () => ({
  type: LOAD_SPONSORS_SAGA
})

export const addAdminSponsors = (values, count, page, total_pages, query = {}) => ({
  type: ADD_ADMIN_SPONSORS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const addSponsors = (values) => ({
  type: ADD_SPONSORS,
  payload: {
    values
  }
})

export const adminDeleteSponsorSaga = (sponsor_ids) => ({
  type: ADMIN_DELETE_SPONSORS_SAGA,
  sponsor_ids
})

export const setTempSponsor = (sponsor) => ({
  type: SET_TEMP_SPONSOR,
  payload: {
    sponsor
  }
})

export const loadSponsorSaga = (id) => ({
  type: LOAD_SPONSOR_SAGA,
  id
})

export const cleanSponsor = () => ({
  type: CLEAN_SPONSORS
})



/** WEBPACK FOOTER **
 ** ./src/actions/sponsors.js
 **/